import '@animoto/common-styles/dist/animoto.webfonts.css';
import '@animoto/components/lib/es/design-system/tokens.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { initializeSentry } from '@animoto/utils/sentry';
import { setToken } from '../../utils/appservice';
import { setUserAttributes, isRegisteredUser as getIsRegisteredUser } from '../../utils/userWrapper';
import PlayApp from './components/PlayApp';

export default function bootstrap(elementId, settings) {
  initializeSentry();
  setUserAttributes(settings.currentUserAttributes);
  const isRegisteredUser = getIsRegisteredUser();

  if (isRegisteredUser) {
    setToken();
  }

  ReactDOM.render(
    <PlayApp {...settings.params} isRegisteredUser={isRegisteredUser} />,
    document.getElementById(elementId)
  );
}
